module.exports = __webpack_public_path__ + "static/media/pass-bloqueo.2f92c5e6.svg";